module.exports = {"id":"153177","name":"Mauro Zárate","rating":"77","photo":"./data/images/photos/0/153177.png","club":{"name":"Vélez Sarsfield","logo":"./data/images/clubs/VelezSarsfield.png"},"positions":["BU","ATT","MOC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MauroZarate0.json
// module id = 2931
// module chunks = 0